import { render } from "./ListeArchivePartieAdmin.vue?vue&type=template&id=f28a5302&scoped=true"
import script from "./ListeArchivePartieAdmin.vue?vue&type=script&lang=js"
export * from "./ListeArchivePartieAdmin.vue?vue&type=script&lang=js"

import "./ListeArchivePartieAdmin.vue?vue&type=style&index=0&id=f28a5302&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f28a5302"]])

export default __exports__